import { render, staticRenderFns } from "./WonderTopicTable.vue?vue&type=template&id=c9345af8&scoped=true"
import script from "./WonderTopicTable.vue?vue&type=script&lang=js"
export * from "./WonderTopicTable.vue?vue&type=script&lang=js"
import style0 from "./WonderTopicTable.vue?vue&type=style&index=0&id=c9345af8&prod&scoped=true&lang=css"
import style1 from "./WonderTopicTable.vue?vue&type=style&index=1&id=c9345af8&prod&lang=css"
import style2 from "./WonderTopicTable.vue?vue&type=style&index=2&id=c9345af8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9345af8",
  null
  
)

export default component.exports